import React from 'react'

const LinkTag: React.FunctionComponent<any> = ({ children, loading, ...tagProps }) => <a {...tagProps}>{children}</a>

export default LinkTag
